import { Component, Input } from '@angular/core';
import { RippleDirective } from '../../../directives/ripple.directive';
import { NgClass } from '@angular/common';

export type ButtonColor = 'orange' | 'grey';

/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: 'a[app-button], button[app-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [RippleDirective, NgClass],
})
export class ButtonComponent {
  @Input() public color?: ButtonColor;
}
